import toast from 'react-hot-toast';
import secureAxios from '../secure_axios';
import { parsePath } from 'react-router-dom';

const baseUrl = 'ponto-facultativo'

async function servPostPontoFacultativo(pontoFacultativoPayload) {
    const { data } = await secureAxios.post(`${baseUrl}`, pontoFacultativoPayload)
    return data
}

async function servGetPontosFacultativosMes(mesReferencia) {
    const { data } = await secureAxios.get(
        `${baseUrl}`,
        { params: { mesReferencia } }
    )
    return data
}

async function servDelPontoFacultativo(pontoFacultativoId) {
    const { data } = await secureAxios.delete(
        `${baseUrl}`,
        { params: { pontoFacultativoId } }
    )
    return data
}

export {
    servPostPontoFacultativo,
    servGetPontosFacultativosMes,
    servDelPontoFacultativo
}